import React from "react";
import "./BracketTeamPublic.css";

export default function BracketTeamPublic({ match, existingGame }) {
 if (!match) return null;

 const scoreA =
  existingGame?.score_home ?? existingGame?.score_team1 ?? null;
 const scoreB =
  existingGame?.score_away ?? existingGame?.score_team2 ?? null;

 const hasScore = scoreA != null && scoreB != null;

 const teamALost = hasScore && scoreA < scoreB;
 const teamBLost = hasScore && scoreB < scoreA;
 const getBracketSeedLabel = (team) => {
  if (!team) return "";

  if (typeof team._originalSlot === "number") {
   return `(${team._originalSlot + 1}) `;
  }

  if (team._slotLabel) {
   const seedNumber = team._slotLabel.replace("Slot ", "");
   return `(${seedNumber}) `;
  }

  return "";
 };

 const getDisplayTeamName = (team) => {
  if (!team) return "TBD";

  if (!team.slt_id) return "TBD";

  if (!team.name || team.name === "TBD") return "TBD";

  if (team.name.startsWith("Slot")) return "TBD";

  return team.name;
 };
 return (
  <div className="bracket-public-row">
   {/* TEAM A */}
   <span className={`team-public ${teamALost ? "team-lost" : ""}`}>
    {getBracketSeedLabel(match.teamA)}
    {getDisplayTeamName(match.teamA)}
   </span>

   {/* {scoreA != null && <span className="score">{scoreA}</span>} */}

   <span className="vs">vs</span>

   {/* {scoreB != null && <span className="score">{scoreB}</span>} */}

   {/* TEAM B */}
   <span className={`team-public ${teamBLost ? "team-lost" : ""}`}>
    {getBracketSeedLabel(match.teamB)}
    {getDisplayTeamName(match.teamB)}
   </span>
  </div>
 );
}
